export type GetProjectResponse = ProjectSummary

export enum ProjectType {
  SNOWFLAKE = 'snowflake',
  DATABRICKS = 'databricks',
  REDSHIFT = 'redshift'
}

export interface ProjectSummary {
  id: string
  name: string
  description: string
  warehouse: ProjectType
}
